import script from "./UCDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./UCDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./UCDatePicker.vue?vue&type=style&index=0&id=ddc42184&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc42184"]])

export default __exports__